import { GameplaySkeleton } from "@modules/shared/components/GameplaySkeleton";
import dynamic from "next/dynamic";

export default dynamic(
    () => import("@modules/home/view/privacy-policy/PrivacyPolicy"),
    {
        ssr: false,
        loading: () => <GameplaySkeleton id="PrivacyPolicyPage" />,
    },
);
